import type { novaToolDefs } from '@newfront-insurance/ai-api';
import type { InferUITool, ToolUIPart } from 'ai';

import { GeneratedFilesList } from './process-files-tool';

type FillSl1FormOutput = InferUITool<(typeof novaToolDefs)['fillSl1Form']>['output'];

interface FillSl1FormToolProps {
  part: ToolUIPart;
}

/**
 * Component for rendering fillSl1Form tool output.
 */
export function FillSl1FormTool({ part }: FillSl1FormToolProps) {
  if (part.state !== 'output-available') return null;

  const output = part.output as FillSl1FormOutput;
  if (output?.generatedFileUuids) {
    return (
      <GeneratedFilesList
        files={output.generatedFileUuids.map((uuid, idx) => ({ uuid, filename: `SL1 form ${idx + 1}.pdf` }))}
      />
    );
  }

  return null;
}
